import {
  EVENT_CATEGORY,
  EVENT_FIELDS,
} from "../constants/garfieldEvents";

const garfieldObjectName = "gfd";

export const sendClickEvent = (eventName, value) => {
  typeof window !== "undefined" &&
    window["gfd"] &&
    window["gfd"]("send", {
      eventType: "click",
      eventName,
      value,
    });
};

export const addGarfield = () => {
  window["GaNamespaceId"] = "SB_WEB";
  window["GarfieldObjName"] = garfieldObjectName;
  window[garfieldObjectName] =
    window[garfieldObjectName] ||
    function () {
      (window[garfieldObjectName].q =
        window[garfieldObjectName].q || []).push(arguments);
    };
  window[garfieldObjectName].l = 1 * new Date();
  let a = document.createElement("script"),
    m = document?.getElementsByTagName("script")[0];
  a.async = 1;
  a.src =
    "https://static.share.market/web/trade/js/garfield-js.44e31309.js";
  m.parentNode.insertBefore(a, m);
};

export const sendPageView = () => {
  window?.[garfieldObjectName] &&
    window?.[garfieldObjectName]("send", {
      eventType: "pageview",
      eventName: "PageView",
    });
};

export const initialiseClientId = () => {
  window?.[garfieldObjectName] &&
    window?.[garfieldObjectName]("create", {
      id: "SB_WEB",
    });
};

export const triggerCalculatorEvent = (
  eventName,
  metaObj
) => {
  const eventMeta = {
    [EVENT_FIELDS.CATEGORY]: EVENT_CATEGORY.CALCULATORS,
    // TODO: will pass source after buzz home page created
    [EVENT_FIELDS.SOURCE]: "",
    ...metaObj,
  };
  sendClickEvent(eventName, eventMeta);
};
